/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

/*
type TypeProps = {
    formData: Object
} & TranslatorProps;
*/

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class UnarchiveProjectSuccess extends React.Component<*> {
  componentDidMount() {
    const response: Object = this.props.response;
    this.props.projectDetailsStore.changeStatus(response.status);
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const response: Object = this.props.response;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.unarchived')}
          >
            <p>{t('general:projects.messages.unarchived')}</p>
            <React.Fragment>
              <ul>
                <li>
                  <b>{t('general:project')}</b>:
                </li>
                <li>{`${response.code} - ${response.name}`}</li>
              </ul>
            </React.Fragment>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
